<template>

  <panel-navigation>
    
    <h1 class="text-lg font-semibold mb-3">Radius</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div v-if="me" class="dashboard-box stats-box w-full px-2 -mx-2"   :style="((me.lsa_command_enabled) ? 'height: 100%;' : '')">
      <v-card
        class="pa-2 h-full"
        tile
          :style="((me.lsa_command_enabled) ? 'height: 100%;' : '')"
      >
        <div v-if="me" :class="'w-full mb-3 p-3'" :style="((me.lsa_command_enabled) ? 'height: 100%;' : '')">
          <div v-if="!me.lsa_command_enabled">
            <product-access-required product="lsa_command" />
          </div>

          <div v-else :style="((me.lsa_command_enabled) ? 'height: 100%;' : '')">
            <iframe :src="'https://lsa-service-area-extractor-395t.vercel.app/?selected_client_id=' + getClientId() + '&username=' + getUsername() + '&account_id=' + getAccountId()" style="width: 100%; height: calc(100% - 100px);"></iframe>
          </div>
        </div>
      </v-card>
    </div>

  </panel-navigation>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'
import ProductAccessRequired from '@/components/reusable/ProductAccessRequired.vue'

export default {
  metaInfo () {
    return {
      title: "LSA Service Areas Tool | " + this.$appName
    }
  },

  computed: {
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile,
    })
  },

  components: {
    PanelNavigation,
    ProductAccessRequired
  },

  data () {
    return {
      
    }
  },

  methods: {
    getClientId() {
      if (this.me) {
        if (this.me.integrations.google_ads.status == 1) {
          if (this.me.integrations.google_ads.settings.selected_client_id)
            return this.me.integrations.google_ads.settings.selected_client_id;
        }
      }

      return "";
    },

    getAccountId() {
      return this.me.id;
    },

    getUsername() {
      // return this.profile.first_name + ' ' + this.profile.last_name;
      return 'Admin';
    }
  },

  created() {
    return; 

    /*let self = this;
    tryUpvoty();

    function tryUpvoty() {
      console.log('try upvoty');
      if (!self.profile) {
        setTimeout(function() {
          tryUpvoty();
        }, 100);
        return;
      }

      upvoty.init('identify', {
          user: {
              id: self.profile.id,
              name: self.profile.first_name + " " + self.profile.last_name,
              email: self.profile.email,
          },
          baseUrl: 'accelerate-marketing.upvoty.com',
          publicKey: 'c9cae0d2de0535b6fa060a0119cef172',
      });

      setTimeout(function() {
        upvoty.init('render', {
          'ssoToken': null,
          'baseUrl': 'accelerate-marketing.upvoty.com'
        });
      }, 1000);
    }*/
  }
}
</script>